import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS } from "@/lib/siteData";

export const ServiceAreas = () => {
  return (
    <section id="areas" data-testid="service-areas" className="py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-neutral-400 mb-4">Where we work</p>
          <h2 className="font-display font-extrabold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl">
            Serving the<br /><span className="brand-gradient-text">entire GTA.</span>
          </h2>
          <p className="mt-6 text-base md:text-lg text-neutral-600 max-w-md">
            Based in Mississauga and covering the Greater Toronto Area. If you're nearby, we can help — just call to confirm.
          </p>
          <div className="mt-8 relative aspect-[16/10] rounded-3xl overflow-hidden ring-1 ring-black/10">
            <motion.img
              src="https://static.prod-images.emergentagent.com/jobs/36f07a14-fbfd-40ed-beed-64eab2ff40a0/images/293c084504935a4db33a849402fbe89a5f8ee1ec3f06d61e9312823784fa159d.jpeg"
              alt="Plumber installing a toilet"
              className="h-full w-full object-cover"
              initial={{ scale: 1.08 }}
              animate={{ scale: [1.08, 1.16, 1.08] }}
              transition={{ duration: 14, ease: "easeInOut", repeat: Infinity }}
            />
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="flex flex-wrap gap-3">
            {SERVICE_AREAS.map((a, i) => (
              <motion.span
                key={a}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.03 }}
                data-testid={`area-${i}`}
                className="inline-flex items-center gap-2 rounded-full border-2 border-black bg-[#FEBE10] px-5 py-3 text-base md:text-lg font-semibold text-[#111111] hover:bg-[#ffcb2e] transition-colors duration-300"
              >
                <MapPin className="h-4 w-4 text-[#111111]" /> {a}
              </motion.span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
